import { render, staticRenderFns } from "./limitInput.vue?vue&type=template&id=20b8f56a&"
import script from "./limitInput.vue?vue&type=script&lang=js&"
export * from "./limitInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports